<p-card header="Draw Result Information">
  <button
    pButton
    pRipple
    label="Add Result"
    class="p-button-success mb-3"
    (click)="onClickAdd()"
  ></button>
  <div class="card">
    <p-table [value]="results" [tableStyle]="{ 'min-width': '50rem' }"       
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50, 100, 1000, 10000]">
      <ng-template pTemplate="header">
        <tr>
          <th>Date</th>
          <th>Type</th>
          <th>Time</th>
          <th>Result</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-result>
        <tr>
          <td>{{ result.date }}</td>
          <td>{{ result.game }}</td>
          <td>{{ result.time }}</td>
          <td>{{ result.result }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>

<p-dialog header="ADD" [(visible)]="visible" [style]="{ width: '50vw' }">
  <div class="grid">
    <div class="col-4">
      <div class="flex flex-column gap-2">
        <label htmlFor="">Date</label>
        <input
          pInputText
          id="date"
          aria-describedby="date-help"
          [(ngModel)]="date"
          [readOnly]="true"
        />
      </div>
    </div>
    <!-- <div class="col-4">
      <div class="flex flex-column gap-2">
        <label htmlFor="date">Date</label>
        <p-calendar
          [style]="{ width: '100%' }"
          [(ngModel)]="date"
          [showButtonBar]="true"
          appendTo="body"
          [showIcon]="true"
          [readonlyInput]="true"
        ></p-calendar>
      </div>
    </div> -->
    <div class="col-4">
      <div class="flex flex-column gap-2">
        <label htmlFor="game">Select Game</label>
        <p-dropdown
          [style]="{ width: '100%' }"
          optionLabel="name"
          placeholder="Select a Game"
          optionValue="name"
          [options]="games"
          [(ngModel)]="gamevalue"
          (onChange)="SelectGame()"
        ></p-dropdown>
      </div>
    </div>
    <div class="col-4">
      <div class="flex flex-column gap-2">
        <label htmlFor="game">Select Time</label>
        <p-dropdown
          [style]="{ width: '100%' }"
          optionLabel="value"
          [showClear]="true"
          optionValue="value"
          [options]="time"
          [(ngModel)]="timevalue"
        ></p-dropdown>
      </div>
    </div>
    <div class="col-12 flex align-items-center justify-content-center">
      <div
        class="flex flex-column gap-2 text-bold align-items-center justify-content-center"
      >
        <label
          htmlFor="result"
          [style]="{
            'text-align': 'center',
            'font-size': '1.5em',
          }"
          >Result</label
        >
        <ng-container *ngIf="!inputText2D3D">
          <input
            pInputText
            id="result3D"
            aria-describedby="username-help"
            [(ngModel)]="result3D"
            maxlength="3"
            [style]="{
            'font-weight': 'bold',
            'font-size': '1.5rem',
            'width': '60%',
          }"
            class="p-inputtext-lg text-center"
          />
        </ng-container>
        <ng-container *ngIf="inputText2D3D">
          <div class="flex grid">
            <div class="col-6" [style]="{ 'text-align': 'right' }">
              <input
                pInputText
                id="resultSTL2D_1"
                aria-describedby="resultSTL2D_1-help"
                [(ngModel)]="resultSTL2D_1"
                [style]="{
                  'font-weight': 'bold',
                  'font-size': '1.5rem',
                  width: '30%',
                }"
                class="p-inputtext-lg text-center text-bold"
              />
            </div>
            <div class="col-6">
              <input
                pInputText
                id="resultSTL2D_2"
                aria-describedby="resultSTL2D_2-help"
                [(ngModel)]="resultSTL2D_2"
                [style]="{ 'font-weight': 'bold', 'font-size': '1.5rem', 'width': '30%', }"
                class="p-inputtext-lg text-center text-bold"
              />
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="flex flex-row-reverse flex-wrap">
    <button
      pButton
      pRipple
      label="SAVE"
      class="p-button-info mt-3 ml-2"
      (click)="Save()"
    ></button>
  </div>
</p-dialog>
